import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { CardActionToggle } from '@/common/components/CardActionToggle/CardActionToggle';
import { Icon } from '@/common/components/Icons/Icon';
import { Translate } from '@/common/components/Translate/Translate';
import { BiometricsType, useBiometrics } from '@/common/hooks/useBiometrics';
import { notify } from '@/common/utils/toast/toast';

const BiometricsToggle: FunctionComponent = (props) => {
  const { t } = useTranslation();
  const {
    biometricsAvailable,
    enableBiometrics,
    biometricsType,
    biometricsEnabled,
    disableBiometrics,
  } = useBiometrics();
  const [toggleActive, setToggleActive] = useState(false);

  useEffect(() => {
    setToggleActive(biometricsEnabled);
  }, [biometricsEnabled]);

  if (Platform.OS === 'web' || !biometricsAvailable) return null;

  const onToggleChange = async () => {
    try {
      if (toggleActive) {
        setToggleActive(false);
        await disableBiometrics();
        return;
      }

      const result = await enableBiometrics();
      setToggleActive(result);
    } catch (err: any) {
      notify({
        type: 'error',
        message: (
          <Translate
            i18nKey={
              'authentication.biometrics.errors.biometrics_activation_failed'
            }
          />
        ),
      });
    }
  };

  return (
    <CardActionToggle
      icon={
        <Icon
          icon={
            biometricsType === BiometricsType.FACE_ID
              ? 'face-viewfinder'
              : 'fingerprint'
          }
        />
      }
      title={t('dashboard.profile.sections.settings.biometrics.title')}
      onChange={onToggleChange}
      checked={toggleActive}
      {...props}
    />
  );
};

export default BiometricsToggle;
